import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLInt,
  GraphQLList,
  GraphQLNonNull,
  GraphQLID
} from 'graphql';

import { connectionArgs, connectionFromArray } from 'graphql-relay';

import AuthType from './auth.gql';
import CourseType from './course.gql';
import Node from './node.gql';
import TeamType from './team.gql';
import ChannelType from './channel.gql';
import ChannelCardType from './channelCard.gql';
import CourseCurriculumUnionType from './courseCurriculumUnion.gql';
import CourseCurriculumTrackUnionType from './courseCurriculumTrackUnion.gql';
import TrainingGroupUnionType from './trainingGroupUnion.gql';
import CustomPropertyValueType from './customPropertyValue.gql';

import notificationConnection from '../connections/notificationType';

const userType = new GraphQLObjectType({
  name: 'User',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID)
    },
    pid: {
      type: GraphQLString
    },
    email: {
      type: GraphQLString
    },
    realEmail: {
      type: GraphQLString
    },
    name: {
      type: GraphQLString
    },
    picture: {
      type: GraphQLString
    },
    companyId: {
      type: GraphQLString
    },
    company_name: {
      type: GraphQLString
    },
    unreadNotificationCount: {
      type: GraphQLInt
    },
    actorType: {
      type: GraphQLString
    },
    allCompanies: {
      type: new GraphQLList(AuthType),
      resolve: item => item.allCompanies.slice()
    },
    notificationNew: {
      type: notificationConnection,
      args: {
        notificationType: {
          type: GraphQLString
        },
        ...connectionArgs
      },
      resolve: (item, args) => connectionFromArray(item.notificationNew.slice(), args)
    },
    allEnrollments: {
      type: new GraphQLList(CourseType),
      resolve: item => item.allEnrollments.slice()
    },
    reportsTo: {
      type: new GraphQLList(userType),
      resolve: item => item.reportsTo.slice()
    },
    userTeams: {
      type: new GraphQLList(TeamType),
      resolve: item => item.userTeams.slice()
    },
    allAvailableContent: {
      type: new GraphQLList(CourseCurriculumUnionType),
      resolve: item => item.allAvailableContent.map(content => content[content.type])
    },
    allAssignedContent: {
      type: new GraphQLList(CourseCurriculumTrackUnionType),
      resolve: item => item.allAssignedContent.map(content => ({
        ...content[content.type],
        modelName: content.type
      }))
    },
    completeLibrary: {
      args: {
        filters: {
          type: new GraphQLList(GraphQLString)
        },
        ...connectionArgs
      },
      type: new GraphQLList(TrainingGroupUnionType),
      resolve: (item, args) => {
        let contents = [];
        if (args.filters.includes('course')) {
          contents = contents.concat(
            item.completeLibraryCourses.map(content => ({ ...content, modelName: 'course' }))
          );
        }
        if (args.filters.includes('curriculum')) {
          contents = contents.concat(
            item.completeLibraryCurriculums.map(content => ({
              ...content,
              modelName: 'curriculum'
            }))
          );
        }
        if (args.filters.includes('channel')) {
          contents = contents.concat(
            item.completeLibraryChannels.map(content => ({ ...content, modelName: 'channel' }))
          );
        }
        return contents;
      }
    },
    lastActive: {
      type: GraphQLString
    },
    newChannels: {
      type: new GraphQLList(ChannelType),
      resolve: item => item.newChannels.slice()
    },
    lastVisitedCourse: {
      type: new GraphQLList(CourseType),
      resolve: item => item.lastVisitedCourse.slice()
    },
    myApprovedChannelCards: {
      type: new GraphQLList(ChannelCardType),
      resolve: item => item.myApprovedChannelCards.slice()
    },
    customProperties: {
      type: new GraphQLList(CustomPropertyValueType),
      resolve: item => item.customProperties.slice()
    }
  }),
  interfaces: [Node.nodeInterface]
});

window[userType.name + 'GQLType'] = userType;

export default userType;
